import { checkDuplicateFaceEnrollmentUseCase } from '@/modules/attendance/application/use-cases/checkDuplicateFaceEnrollmentUseCase';
import type { FaceEmbedding } from '@/modules/attendance/domain/valueObjects/FaceEmbedding';

export interface EnrollSaveGateInput {
  embedding: FaceEmbedding;
  accessRoleId: number;
  idPerson: number;
}

export interface EnrollSaveGateResult {
  conflict: boolean;
  conflictingIdPerson?: number | undefined;
  conflictingFullName?: string | undefined;
  navigateTo?: string | undefined;
  navigateState?: unknown;
}

/**
 * Pure gate: runs duplicate-face pre-check before persisting an enrollment.
 * Extracted to a dedicated module so it can be tested independently without
 * importing the AdminEnrollFacePage component (avoids react-refresh warnings).
 */
export async function runEnrollSaveGate(
  input: EnrollSaveGateInput,
): Promise<EnrollSaveGateResult> {
  const check = await checkDuplicateFaceEnrollmentUseCase(
    input.embedding,
    input.accessRoleId,
    input.idPerson,
  );
  if (check.conflict) {
    return {
      conflict: true,
      conflictingIdPerson: check.conflictingIdPerson,
      conflictingFullName: check.conflictingFullName,
      navigateTo: `/admin/empleados/${input.idPerson}/enroll/photo/duplicate-face`,
      navigateState: {
        conflictingEmployee: {
          idPerson: check.conflictingIdPerson,
          fullName: check.conflictingFullName,
        },
      },
    };
  }
  return { conflict: false };
}
